const initialState: BankState = {
  name: null,
};

export default function bankReducer(
  state = initialState,
  action: { type: string; name?: string | null }
) {
  switch (action.type) {
    case "UPDATE_BANK":
      return {
        ...state,
        name: action.name ?? null,
      };
    default:
      return state;
  }
}
